import { useEffect, useState } from 'react';
import MainButton from '../components/buttons/MainButton';
import { Spinner } from 'flowbite-react';
import UserService from '../services/httpServices/user.service';
import { useLocation, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import ToastService from '../services/toastService';
import UtilsService from '../services/utils.service';

export default function ValidateEmailView(): JSX.Element {

  const { showSuccessToast, showErrorToast, } = ToastService();
  const { validateEmail, registerUserWithTrial } = UserService();
  const navigate = useNavigate();
  const { paymentHelper } = UtilsService();

  const [validationError, setValidationError] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState<{ email: string } | null>(null);
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  const shadowStyle = "sm:shadow-xl";

  useEffect(() => {
    try{
      const decodedToken : any = jwt_decode(token!);
      setUserInfo(decodedToken)
      validateEmail(token, {email: decodedToken.email})
    } catch(error) {
      console.log("ERROR", error)
      setValidationError(true)
    }

  }, []);

  const subscriptionHandler = async () => {
    try {
      if (!userInfo) {
        throw new Error("User info is not available");
      }

      if (!userInfo.email) {
        throw new Error("Email is not available");
      }

      await paymentHelper(userInfo?.email);
    }
    catch (error) {
      showErrorToast('No se ha podido realizar la suscripción, inténtelo más tarde');
      setValidationError(true)
    }
  }

  const trialModeHandler = async () => {
    try {
    await registerUserWithTrial(userInfo);
    showSuccessToast(`Se ha completado el registro correctamente. Inicia sesión para acceder a la plataforma.`);
    navigate('/login');
    } catch (error) {
      showErrorToast(`Ha ocurrido un problema al completar el registro. Si el problema persiste póngase en contacto con nosotros`);
    }
  }

  return (
    <div className='flex-1 flex justify-center items-center sm:pb-20 border-t-[1px] border-gray-200'>
      <div className={`w-full flex justify-center flex-col p-10 bg-white rounded-lg sm:max-w-xl ${shadowStyle}`}>
        <h1 className="text-3xl font-semibold text-center text-primary-100 m-5">
          Registro
        </h1>
        {isLoading ?
          <div className='text-center my-6'>
            <Spinner className="fill-primary-100"/>
          </div>:<><>
          {!validationError ?
            <>
              <p className="text-base font-semibold text-center text-text-200 mb-5">
                Para terminar el registro seleccione uno de los siguientes métodos de suscripción
              </p>
              <><div>
                  <MainButton
                    isSubmitButton={true}
                    value="subscription"
                    name="subscription"
                    className="w-full"
                    onClick = {subscriptionHandler}
                  >
                    Acceder al pago
                  </MainButton>
                  <MainButton
                    value="trial-mode"
                    isSubmitButton={true}
                    name="trial-mode"
                    className="w-full mt-3"
                    onClick = {trialModeHandler}
                  >
                    Probar durante 2 horas
                  </MainButton>
                </div>
              </>
            </> :
              <p className="text-base font-semibold text-center text-text-200 mb-5">
                El token de validación no es correcto o ha caducado, vuelva a realizar el registro en la plataforma para validar el correo. Si el problema persiste, póngase en contacto con nosotros.
              </p>
            }</></>
        }
      </div>
    </div>
  );
}
